import axios from 'axios';
import store from '../store';
import { logout, setCredentials } from './authSlice';

const Swal = window.Swal;

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = store.getState().auth.accessToken;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      const result = await Swal.fire({
        title: "Session Expired",
        text: "Your session has expired. Do you want to regenerate?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Regenerate",
        cancelButtonText: "Logout",
      });

      if (result.isConfirmed) {
        try {
          const res = await axios.post(
            '/auth/token/refresh',
            {},
            {
              baseURL: process.env.REACT_APP_API_URL,
              withCredentials: true,
            }
          );

          const newToken = res.headers['authorization'];
          store.dispatch(setCredentials(newToken));

          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
          return api(originalRequest);
        } catch (err) {
          store.dispatch(logout());
          return Promise.reject(err);
        }
      } else {
        store.dispatch(logout());
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
